/**
 * Formatting utilities for MembersScreen
 */

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "—";

  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, "");

  // Check if it's a 10-digit number (assuming North American format)
  if (cleaned.length === 10) {
    return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6
    )}`;
  }

  // If it's 11 digits and starts with 1, format accordingly
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(
      7
    )}`;
  }

  // Return original if it doesn't match expected format
  return phoneNumber;
};
